module.exports = __webpack_public_path__ + "img/img-6.b9d061a9.webp";